import { componentsTranslationKeys, dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { DocumentTemplateFormController } from '~libs.desktop.shared.document-template';

import { visitTranslationKeys } from '../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../visit/visit.draft';

import { getDocumentTemplateDraftToken } from './documentTemplate.draft';
import { translationKeys } from './translations';

type DocumentTemplateFormLeavingGuardProps = Pick<DocumentTemplateFormController, 'handleSubmitDraft' | 'formState'> & {
   readonly visitId: number;
   readonly printTemplateId: number;
};

export const DocumentTemplateFormLeavingGuard = (props: DocumentTemplateFormLeavingGuardProps): JSX.Element => {
   const { executeAsync: saveDocumentTemplateDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });

   const handleLeave = props.handleSubmitDraft(async (formData) =>
      saveDocumentTemplateDraft({
         token: getDocumentTemplateDraftToken(props.visitId, props.printTemplateId),
         tags: [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
         contents: formData,
      })
   );

   return (
      <RouteLeavingGuard
         testId={'formLeavingConfirmation'}
         title={componentsTranslationKeys.leaveForm}
         message={componentsTranslationKeys.formLeavingConfirmation}
         successMessage={translationKeys.documentTemplateDraftSaved}
         onLeave={handleLeave}
         active={props.formState.isDirty}
      />
   );
};
